import "./HtmlEmbed.style.scss";
import { replaceImgWithAmpImg } from "@inferno/renderer-shared-core";
import type { HtmlProps } from "@ihr-radioedit/inferno-core";

export const HtmlEmbed = ({ amp, value }: HtmlProps) => {
  if (!value) {
    return null;
  }

  if (amp && value.includes("<img")) {
    value = replaceImgWithAmpImg(value);
  }

  return <div className="component-embed-html" dangerouslySetInnerHTML={{ __html: value }} />;
};

export default HtmlEmbed;
